var render = function render(){var _vm=this,_c=_vm._self._c;return _c('K2Row',{staticClass:"K2Input",attrs:{"space-between":"true","align":"center"},on:{"onclick":_vm.copyText}},[_c('input',{ref:"inputToCopy",domProps:{"value":_vm.value}}),_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px","top":"0","width":"30px","text-align":"center","cursor":"pointer"}},[_vm._v("content_copy")])])
}
var staticRenderFns = []

export { render, staticRenderFns }